<template>
  <div class="inquireOffer"
       @scroll='onscrollEvent'
       v-loading="fullscreenLoading">

    <el-dialog title="计算报价"
               :visible.sync="computedShow"
               width="800px"
               :before-close="handleClose">

      <div class="result_view"
           v-if="selectRow.id">
        <el-descriptions class="margin-top"
                         title="包裹信息"
                         :column="4"
                         direction="vertical"
                         size="small"
                         border>
          <el-descriptions-item label='包裹总体积'>
            {{inqueryResult.tj/1000000}} CBM
          </el-descriptions-item>
          <el-descriptions-item label='包裹总重量'>
            {{inqueryResult.weight}} KG
          </el-descriptions-item>
          <el-descriptions-item label='单价'>
            {{inqueryResult.dj}} 元
          </el-descriptions-item>
          <el-descriptions-item label='附加费'>
            {{inqueryResult.fjf}} 元
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top"
                         title="计费信息"
                         :column="4"
                         direction="vertical"
                         size="small"
                         border>
          <el-descriptions-item label='计费重'>
            {{inqueryResult.totalWeight}} KG
          </el-descriptions-item>
          <el-descriptions-item label='首重'>
            {{ selectRow.iteminfo.oneweight}} KG
          </el-descriptions-item>
          <el-descriptions-item label='续重单位'>
            {{inqueryResult.xzdw}}
          </el-descriptions-item>
          <el-descriptions-item label='材积系数'>
            {{selectRow.iteminfo.cjxs}} 材
          </el-descriptions-item>
          <el-descriptions-item label='起步价'>
            {{inqueryResult.starprice}} 元
          </el-descriptions-item>
          <el-descriptions-item label='续重价'>
            {{inqueryResult.additionPrice}} 元
          </el-descriptions-item>
          <el-descriptions-item label='运费（不含报关，燃油等）'>
            {{inqueryResult.totalPrice}} 元
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top"
                         title="计费说明"
                         :column="1"
                         direction="vertical"
                         size="small"
                         border>
          <el-descriptions-item label='总价格说明'
                                v-if="inqueryResult.text">
            <div v-html="inqueryResult.text"
                 class="inqueryItem"></div>
          </el-descriptions-item>
          <el-descriptions-item label='起步价说明'
                                v-if="inqueryResult.starpriceTexe">
            <div v-html="inqueryResult.starpriceTexe"
                 class="inqueryItem"></div>
          </el-descriptions-item>
          <el-descriptions-item label='续重价说明'
                                v-if="inqueryResult.xzprice">
            <div v-html="inqueryResult.xzprice"
                 class="inqueryItem"></div>
          </el-descriptions-item>
        </el-descriptions>

      </div>
    </el-dialog>

    <el-dialog title="计算报价"
               :visible.sync="dialogVisible"
               width="1000px"
               :before-close="handleClose">
      <div class="computed_offer">
        <el-table :data="computeTable"
                  height="500px"
                  border
                  style="width: 100%">
          <el-table-column prop="c"
                           align="center"
                           label="长度 ( CM )">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.c"
                               :min="1"
                               :precision='2'
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </template>
          </el-table-column>

          <el-table-column prop="k"
                           align="center"
                           label="宽度 ( CM )">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.k"
                               :min="1"
                               :precision='2'
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="g"
                           align="center"
                           label="高度 ( CM )">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.g"
                               :min="1"
                               :precision='2'
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="z"
                           align="center"
                           label="重量 ( KG )">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.z"
                               :min="1"
                               :precision='2'
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="n"
                           align="center"
                           label="数量">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.n"
                               :min="1"
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="操作">
            <template slot-scope="scope">
              <el-button type="primary"
                         @click="addPack(scope.$index)"
                         v-if="scope.$index==computeTable.length-1"
                         size="mini">添加</el-button>
              <el-button type="danger"
                         v-if="computeTable.length>1"
                         @click="deleteEle(scope.$index)"
                         size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span class="dialog-footer">
          <div>
            <el-select v-model="selectGoodsType"
                       size="mini"
                       placeholder="请选择支持物品">
              <el-option v-for="item in selectRow.wptype"
                         :key="item.id"
                         :label="`${item.wpname}  价格：${item.price}`"
                         :value="item.id">
              </el-option>
            </el-select>

            <span class="elseDialog">
              其他单价附加费：
              <el-input-number v-model="elsePrice"
                               :min="0"
                               :precision='2'
                               :max="1000"
                               size="mini"
                               label="描述文字"></el-input-number>
            </span>
          </div>
          <div class="dialog_btn">
            <el-button @click="dialogVisible = false"
                       size="small">取 消</el-button>
            <el-button type="primary"
                       @click="inquirePrice()"
                       size="small">查 询</el-button>
          </div>
        </span>
        <div class="wpinfo">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="物品说明"
                              name="1">
              <el-table :data="common.transform(selectRow.wptype)"
                        style="width: 100%">
                <el-table-column prop="wpname"
                                 width="150px"
                                 show-overflow-tooltip
                                 label="物品名">

                </el-table-column>
                <el-table-column prop="info"
                                 show-overflow-tooltip
                                 label="物品说明">

                </el-table-column>
                <el-table-column prop="price"
                                 show-overflow-tooltip
                                 width="100px"
                                 label="价格">

                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-dialog>
    <div class="offerList">
      <div class="offerList_statistics">
        <span>为您找到：<span class="allNum">{{offerAll||0}}</span> 条报价</span>
      </div>

      <div class="offerData"
           v-if='offerAll>0'>
        <div class="offerList_item"
             v-for='item in offerList'
             :key='item.id'>
          <div class="item_left">
            <div class="offer_item_info">
              <div class="offerTitle">
                {{item.bjname}}
              </div>
              <div class="offerTag">
                <el-tag effect="dark"
                        :type="item.iscdf==1?'':'info'"
                        size="mini">
                  {{item.iscdf==1?'支持一般贸易':'不支持一般贸易'}}
                </el-tag>
                <el-tag effect="dark"
                        :type="item.tax=='包税'?'':'info'"
                        size="mini">
                  {{item.tax||'不包税'}}
                </el-tag>
              </div>
              <div class="offerDay">
                <span class="day_view">
                  预估时效：<span class="day_num">{{item.sxday}}</span> 天
                </span>
              </div>
              <div class="offerGs">
                <div class="offerGs_info">
                  {{item.priceinfo}}
                </div>
                <div class="elseInfo">
                  <span class="elseInfo_item">材积系数：{{item.cjxs}}</span>
                  <span class="elseInfo_item">分泡：{{item.paobfb}}%</span>
                  <span class="elseInfo_item">燃油费：{{item.ry}}</span>
                  <el-link type="primary"
                           @click="skipBjDetails(item.id)"
                           class="elseInfo_particulars">
                    查看报价详情数据 <i class="el-icon-d-arrow-right"></i>
                  </el-link>
                </div>
              </div>
            </div>
            <div class="offer_item_price">
              <div>
                <span class="offer_item_price_num"> ￥
                  <span class="number_price"> {{item.minxzprice}}</span>
                </span>
                <span class="offer_item_price_unit"> /{{item.xzdw}}{{item.jzdw}}起</span>
              </div>
              <div class="offer_item_price_info">
                如有疑问，欢迎点击顶部联系客服，专人解决您的疑惑。
              </div>

            </div>
          </div>
          <div class="item_right">
            <el-button type="primary"
                       @click="skip_placeOrder(item.id)"
                       size="medium">开始下单</el-button>
            <div class="calculatePrice">
              <el-link type="primary"
                       @click="dialogVisibleShow(item)">查询具体价格</el-link>
            </div>
          </div>

        </div>

        <div class="loading_view">
          <div v-if="offerList.length!=offerAll">加载中
            <i class="el-icon-loading"></i>
          </div>
          <div v-else>
            没有更多了哦~
          </div>
        </div>
      </div>
      <template v-else>
        <el-empty :image='require("../assets/images/offerNull.png")'
                  :image-size="300"
                  description="没有找到报价哦，换一个条件试试吧。"></el-empty>
      </template>
    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
import { apiOffer } from '@/request/api'
import { computeWeight } from '@/assets/js/price_compute'
export default {
  data () {
    return {
      //  -------------- 【 其他附加费 】 --------------
      elsePrice: 0,
      //  -------------- 【 查询价格结果 】 --------------
      inqueryResult: {},
      //  -------------- 【 公共函数 】 --------------
      common,
      //  -------------- 【 展示的物品 】 --------------
      activeNames: '',
      //  -------------- 【 选择的报价 】 --------------
      selectRow: {
        wptype: []
      },
      //  -------------- 【 选择物品类型 】 --------------
      selectGoodsType: '',
      //  -------------- 【 显示计算结果 】 --------------
      computedShow: false,
      //  -------------- 【 计算表格 】 --------------
      computeTable: [
        {
          c: 0,
          k: 0,
          g: 0,
          z: 0,
          n: 0
        }
      ],
      //  ============== 【 显示计算弹框 】 ==============
      dialogVisible: false,
      //  ============== 【 页码 】 ==============
      page: 1,
      //  ============== 【 局部加载 】 ==============
      fullscreenLoading: false,
      //  ============== 【 订单总数量 】 ==============
      offerAll: 0,
      //  ============== 【 报价列表 】 ==============
      offerList: []
    }
  },
  methods: {
    //  -------------- 【 查询 】 --------------
    inquirePrice () {
      if (this.selectRow.gs == 3) {
        return this.$message('暂时不支持重计方公式模拟。')

      }
      if (this.selectGoodsType == '') {
        return this.$message.error('请选择物品类型。')
      }
      let tj = 0, weight = 0
      for (const key in this.computeTable) {
        tj += this.computeTable[key].c * this.computeTable[key].k * this.computeTable[key].g * this.computeTable[key].n
        weight += this.computeTable[key].z
      }
      console.log(this.computeTable);
      this.inqueryResult = computeWeight(tj, weight, this.selectRow, this.selectGoodsType, this, this.selectRow.iteminfo.oneweight, this.selectRow.iteminfo.starprice, this.elsePrice)
      this.computedShow = true
    },
    //  -------------- 【 删除 】 --------------
    deleteEle (index) {
      this.computeTable.splice(index, 1)
    },
    //  -------------- 【 添加 】 --------------
    addPack () {
      this.computeTable.push({
        c: 0,
        k: 0,
        g: 0,
        z: 0,
        n: 0
      })
    },
    //  -------------- 【 关闭确定 】 --------------
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    //  -------------- 【 弹出弹窗 】 --------------
    dialogVisibleShow (row) {
      row.wpytye = common.transform(row.wptype)
      this.selectRow = row
      this.dialogVisible = true
    },

    //  -------------- 【 跳转下单 】 --------------
    skip_placeOrder (id) {
      if (this.type == 1) {
        this.$router.push({
          name: 'business',
          query: {
            addrid: this.gjid,
            ckid: this.warehouse,
            bjid: id,
          }
        })
      } else {
        this.$router.push({
          name: 'Concentrated',
          query: {
            ckid: this.warehouse,
          }
        })
      }

    },
    //  -------------- 【 跳转报价详情 】 --------------
    skipBjDetails (id) {
      // 可以直接传参数，这里用ID再去请求
      this.$router.push({
        name: this.not ? 'examinePriceDetail' : 'QuoteDetail',
        query: {
          id
        }
      })
    },
    //  -------------- 【 滚动事件 】 --------------
    onscrollEvent (e) {
      if (e.target.scrollTop + e.target.clientHeight == e.target.scrollHeight && this.offerList.length != this.offerAll) {
        this.pageOffer()
      }
    },
    //  -------------- 【 加载下一页报价 】 --------------
    async pageOffer () {
      this.page++
      let res = await this.offerRequest()
      if (res.errno == 0) {
        this.offerList.push(...res.allbj)
      }
    },
    //  -------------- 【 查询报价请求 】 --------------
    async offerRequest () {
      return await apiOffer({
        type: this.type,
        gjid: this.gjid,
        ckid: this.warehouse,
        lineid: this.line_id == 0 ? '' : this.line_id,
        weight: this.weight,
        tj: this.tj,
        fbacode: this.type == 1 ? this.fbacode : '',
        pageSize: 10,
        page: this.page
      })
    },
    //  -------------- 【 查询报价-外部调用进行查询 】 --------------
    async inquireQuote () {
      this.fullscreenLoading = true
      let res = await this.offerRequest()
      if (res.errno == 0) {
        this.offerList = res.allbj
      } else {
        this.offerList = []
      }
      this.offerAll = res.totalNum
      this.fullscreenLoading = false
    },


  },
  filters: {
    gsText (e) {
      switch (e) {
        case '1':
          return '不分泡计算 '
        case '2':
          return '分泡计算'
        case '3':
          return '计材公式'
        default:
          break;
      }
    }
  },
  props: {
    //  ************* 【 FBA仓库代码 】 *************
    fbacode: {
      type: String,
      require: false,
      default: ''
    },
    //  ************* 【 体积 】 *************
    tj: {
      type: [Number, String],
      require: false,
      default: 1
    },
    //  ************* 【 重量 】 *************
    weight: {
      type: [Number, String],
      require: false,
      default: 1
    },
    //  ************* 【 仓库ID 】 *************
    warehouse: {
      type: [Number, String],
      require: true
    },
    //  ************* 【 国家ID 】 *************
    gjid: {
      type: [Number, String],
      require: true
    },
    //  ************* 【 运输类型 】 *************
    type: {
      type: [Number, String],
      require: true
    },
    //  ************* 【 线路ID 】 *************
    line_id: {
      type: [Number, String],
      require: true
    }
  }
}
</script>

<style lang='scss'>
.inquireOffer {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  .result_view {
    .el-descriptions {
      margin-bottom: 20px;
    }
    .el-descriptions__header {
      margin-bottom: 10px;
    }
    .inqueryItem {
      margin-bottom: 10px;
    }
    .priceExplain {
      font-size: 12px;
      margin: 0 1px;
      color: #999;
    }
  }
  .computed_offer {
    .wpinfo {
      margin-top: 20px;
      font-size: 12px;
      .el-collapse-item__header {
        font-size: 12px;
        height: 30px;
      }
    }
    .dialog-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .elseDialog {
        margin-left: 20px;
        font-size: 12px;
      }
    }
    input {
      border: none !important;
      background-color: #fff;
      border-bottom: 1px solid #eee !important;
      border-radius: 0;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      display: none;
    }
  }
  .offerList {
    width: 90%;
    height: 100%;
    .offerList_statistics {
      height: 50px;
      display: flex;
      align-items: center;
      color: #666;
      font-size: 14px;
      letter-spacing: 0.5px;
      .allNum {
        color: #53a8ff;
        font-weight: 700;
        letter-spacing: 0;
      }
    }
    .offerData {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .offerList_item:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .offerList_item {
      width: 100%;
      max-width: 1200px;
      height: 180px;
      background-color: #fff;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      box-shadow: 0;
      transition: all 0.3s;
      display: flex;
      overflow: hidden;
      padding-left: 20px;
      box-sizing: border-box;
      .item_left,
      .item_right {
        flex: 1;
      }
      .item_left {
        flex: 1;
        display: flex;
        .offer_item_info,
        .offer_item_price {
          flex: 1;
        }
        .offer_item_info {
          display: flex;
          flex-direction: column;
          .offerTitle {
            height: 50px;
            line-height: 50px;
            font-weight: 700;
            color: #333;
            font-size: 18px;
            letter-spacing: 1px;
          }
          .offerTag {
            .el-tag {
              margin-right: 10px;
            }
          }
          .offerGs {
            width: 450px;
            height: 60px;
            font-size: 12px;
            margin-top: 10px;
            color: #333;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .offerGs_info {
              width: 300px;
              height: 35px;
              line-height: 1.3em;
              white-space: normal; //规定段落中的文本不进行换行：
              word-break: break-all; //可在任意字符间断行。
              word-wrap: break-word; //在长单词或 URL 地址内部进行换行。
            }
            .el-icon-question {
              color: #666;
            }
            .elseInfo {
              .elseInfo_item {
                margin-right: 15px;
              }
              .elseInfo_particulars {
                color: #53a8ff;
                font-size: 12px;
                font-weight: 700;
              }
            }
          }
          .offerDay {
            font-size: 14px;
            margin-top: 10px;
            .day_view {
              background-color: #f5f5f5;
              padding: 2px 8px;
              border-radius: 4px;
              color: #888;
              .day_num {
                color: #f56c6c;
                font-weight: 700;
              }
            }
          }
        }
        .offer_item_price {
          max-width: 230px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          .offer_item_price_info {
            font-size: 12px;
            text-indent: 2em;
            margin-top: 20px;
            color: #999;
          }
          .offer_item_price_unit {
            font-size: 14px;
            color: #999;
          }
          .offer_item_price_num {
            color: #f56c6c;
            font-size: 12px;
            font-weight: 700;
            .number_price {
              font-size: 26px;
            }
          }
        }
      }
      .item_right {
        flex: 1;
        padding: 30px;
        max-width: 200px;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 10px;
        .el-button {
          width: 100%;
          background-color: #1d8eff;
        }
        .calculatePrice {
          margin-top: 20px;
          font-size: 14px;
          color: #333;
        }
      }
    }
    .loading_view {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #999;
      letter-spacing: 1px;
      font-size: 14px;
    }
  }
}
</style>